import { QuestionBase } from './question-base';

export class InputNumberQuestion extends QuestionBase<string> {
   ptctNo = 'inputnumber';
}
